import { useEffect, useState } from 'react';
import { CalendarHeart, MapPin, Ticket, Check } from 'lucide-react';
import { getMyEvents, MyEventFull, money } from '../api';
import { fmtEventDate } from '../../events/api';
import { Skeleton } from '../../../components/Skeleton';
import EmptyState from '../../../components/EmptyState';

export default function StudentEvents() {
  const [data, setData] = useState<MyEventFull[] | null>(null);
  useEffect(() => { getMyEvents().then((r) => setData(r.data)).catch(() => setData([])); }, []);

  if (!data) return <div className="space-y-4"><Skeleton className="h-56 rounded-2xl" /></div>;

  return (
    <div className="space-y-4">
      <h1 className="font-display text-xl font-bold text-content">Eventos</h1>
      {data.length === 0 ? (
        <EmptyState icon={CalendarHeart} title="Sin eventos por ahora" subtitle="Cuando el estudio organice un evento, aparecerá aquí." />
      ) : (
        <div className="space-y-4">
          {data.map((ev) => (
            <div key={ev.event_id} className="overflow-hidden rounded-2xl border border-line bg-surface shadow-sm">
              <div className="relative aspect-[16/9] w-full bg-surface-2">
                {ev.image_url
                  ? <img src={ev.image_url} alt="" className="h-full w-full object-cover" onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }} />
                  : <div className="h-full w-full" style={{ background: `linear-gradient(135deg, ${ev.event_type_color ? `#${ev.event_type_color}` : 'rgb(var(--c-accent))'}, rgb(var(--c-blue)))` }} />}
                {ev.going && (
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-black/60 px-2 py-0.5 text-[11px] font-medium text-white">
                    <Check size={11} /> Tu lugar confirmado
                  </span>
                )}
              </div>
              <div className="p-4">
                <div className="font-display text-lg font-bold text-content">{ev.name}</div>
                <div className="mt-0.5 text-sm capitalize text-content-2">{fmtEventDate(ev.datetime)}</div>
                {ev.venue && (
                  <div className="mt-1 flex items-center gap-1 text-sm text-content-3">
                    <MapPin size={13} /> {ev.venue}{ev.venue_address ? ` · ${ev.venue_address}` : ''}
                  </div>
                )}
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  {Number(ev.price) > 0 && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-surface-2 px-3 py-1 text-sm font-semibold text-content">
                      <Ticket size={13} /> {money(ev.price)}
                    </span>
                  )}
                  {ev.going
                    ? <span className="inline-flex items-center gap-1 rounded-full bg-accent/15 px-3 py-1 text-sm font-semibold text-accent-ink"><Check size={13} /> Asistirás</span>
                    : <span className="rounded-full bg-surface-2 px-3 py-1 text-sm text-content-3">Pregunta en recepción para tu lugar</span>}
                </div>
                {ev.description && (
                  <div className="mt-3 border-t border-line pt-3 text-sm leading-relaxed text-content-2"
                    dangerouslySetInnerHTML={{ __html: ev.description }} />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
